export const AUDIO = 'AUDIO';
export const VIDEO = 'VIDEO';